export default class SeriesFilter {
    /**
     * @param {string} field
     * @param {boolean|array|null} value
     */
    constructor(field, value) {

        this.field = field;
        this.value = Array.from(value);
    }

    /**
     * Adds given `values` to this filter values.
     *
     * @param {Array} values
     * @returns {SeriesFilter}
     */
    add(values) {
        values.forEach((value) => {
            if (!this.value.includes(value)) {
                this.value.push(value);
            }
        });

        return this;
    }

    /**
     * Removes every value in given `values` from this filter values.
     *
     * @param values
     * @returns {SeriesFilter}
     */
    remove(values) {
        this.value = this.value.filter((existingValue) => {
            return !values.includes(existingValue);
        });

        return this;
    }

}
